import { ReportExamSideBarFilterDatamodel } from '../side-bar-filter/report-exam-side-bar-filter-datamodel';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getExamReportOperation = async (
  setData: (data: any) => any,
  setLoading: (loading: boolean) => any,
  filter: ReportExamSideBarFilterDatamodel,
) => {
  try {
    setLoading(true);
    const res = await appApi.getExamReport(filter);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
